import { Component, Input, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import SwiperCore, {
  EffectCoverflow,
  EffectCube,
  Pagination,
  Navigation,
} from "swiper";
import { CardModel } from "src/app/shared/models/card.model";
// import { ICardCarousel } from "src/app/interfaces/cards-carousel";

SwiperCore.use([EffectCoverflow, EffectCube, Pagination, Navigation]);

@Component({
  selector: "app-carousel",
  templateUrl: "./carousel.component.html",
  styleUrl: "./carousel.component.scss"
})
export class CarouselComponent implements OnInit {
  @Input() title: string = "";
  @Input() subtitle: string = "";
  @Input() alignCard: "center" | "start" | "end" = "center";
  @Input() backgroundImage: string = "";
  @Input() bgColor: string = "";
  @Input() cards: CardModel[] = [];
  @Input() cta: string = '';

  public env = environment;
  responsiveOptions: any[] | undefined;

  constructor() {}

  myConfig = {
    320: {
      slidesPerView: 1,
      spaceBetween: 50,
      slidesPerGroup: 1,
    },

    768: {
      slidesPerView: 2,
      spaceBetween: 50,
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  };
  ngOnInit(): void {}
}
